<app-navbar></app-navbar>

<div class="documentos-wrapper">
  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="loading-container">
    <h3 class="text-center">
      <fa-icon [icon]="faSpinner" [spin]="true"></fa-icon>
      {{ 'Loading' | translate }}
    </h3>
  </div>

  <!-- Hero Section -->
  <div *ngIf="!isLoading" class="hero-section">
    <div class="container">
      <div class="hero-content">
        <span class="hero-tag">DOWNLOADS</span>
        <h1 class="hero-title">Technical resources</h1>
        <p class="hero-subtitle">Find all the product datasheets, manuals, and technical documentation you need in one place.</p>
      </div>
    </div>
  </div>

  <!-- Products Section -->
  <div *ngIf="!isLoading" class="products-section">
  <div class="container">
    
    <!-- Loop por cada empresa -->
    <div *ngFor="let empresa of empresas" class="empresa-group">
      <h2 class="empresa-title">{{ empresa }}</h2>
      
      <div class="row productos-grid">
        <!-- Loop por cada producto de la empresa -->
        <div *ngFor="let producto of productosPorEmpresa[empresa]" 
             class="col-lg-3 col-md-4 col-sm-6 producto-col"
             [ngClass]="{'d-none': !categoriasPorProducto[producto.name1] || categoriasPorProducto[producto.name1].length === 0}">
          
          <div class="producto-card">
            <!-- Imagen del producto -->
            <div class="producto-image-container">
              <img [src]="'https://cms.eft-systems.de/' + producto.img" 
                   [alt]="producto.name1" 
                   class="producto-image">
            </div>
            
            <!-- Nombre del producto -->
            <h3 class="producto-name">{{ producto.name1 | translate }}</h3>
            
            <!-- Categorías -->
            <div class="categorias-list">
              <div *ngFor="let cat of categoriasPorProducto[producto.name1]" class="categoria-item">
                <div *ngIf="cat.name !== 'Subsidy Form'" 
                     class="categoria-header" 
                     (click)="toggleCollapse(producto.name1 + '_' + cat.name, producto.name1, cat.name, $event)">
                  
                  <div class="categoria-header-content">
                    <span class="categoria-icon">
                      <i class="fas" 
                         [ngClass]="{'fa-chevron-down': collapsed[producto.name1 + '_' + cat.name], 
                                     'fa-chevron-up': !collapsed[producto.name1 + '_' + cat.name]}"></i>
                    </span>
                    <span class="categoria-name">{{ cat.name | translate }}</span>
                    
                    <span *ngIf="loadingRenting && lastOpenedId === producto.name1 + '_' + cat.name" 
                          class="loading-spinner">
                      <fa-icon [icon]="faSpinner" [spin]="true"></fa-icon>
                    </span>
                  </div>
                </div>
                
                <!-- Documentos de la categoría -->
                <div *ngIf="!collapsed[producto.name1 + '_' + cat.name]" 
                     class="categoria-documentos">
                  
                  <!-- Mensaje si no hay documentos -->
                  <div *ngIf="mostrarMensajeNoDocumentos && !loadingRenting" 
                       class="alert alert-warning" 
                       [innerHTML]="'No hay documentos disponibles en esta categoría.'|translate">
                  </div>
                  
                  <!-- Lista de documentos -->
                  <div *ngFor="let doc of documentos" class="documento-item">
                    <ng-container *ngIf="doc.category === cat.name && productName === producto.name1 && !loadingRenting && !mostrarMensajeNoDocumentos">
                      <a *ngIf="!doc.file.includes('https')" 
                         href="https://cms.eft-systems.de/{{ doc.file }}" 
                         target="_blank" 
                         class="documento-link">
                        {{ doc.title }}
                      </a>
                      <a *ngIf="doc.file.includes('https')" 
                         href="{{ doc.file }}" 
                         target="_blank" 
                         class="documento-link">
                        {{ doc.title }}
                      </a>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Sección "Otros documentos" (productos sin empresa asignada o con show_title == '0') -->
    <div *ngIf="productosPorEmpresa['Otros'] && productosPorEmpresa['Otros'].length > 0" class="empresa-group">
      <h2 class="empresa-title">{{ 'Otros documentos' | translate }}</h2>
      
      <div class="otros-documentos-list">
        <div *ngFor="let producto of productosPorEmpresa['Otros']" 
             [ngClass]="{'d-none': !categoriasPorProducto[producto.name1] || categoriasPorProducto[producto.name1].length === 0}">
          
          <div *ngFor="let cat of categoriasPorProducto[producto.name1]">
            <div *ngIf="producto.name1 !== 'HVL' && producto.name1 !== 'Commercial' && producto.name1 !== 'Other'" 
                 class="otro-documento-item">
              
              <div class="categoria-header" 
                   (click)="toggleCollapse(producto.name1 + '_' + cat.name, producto.name1, cat.name, $event)">
                <div class="categoria-header-content">
                  <span class="categoria-icon">
                    <i class="fas" 
                       [ngClass]="{'fa-chevron-down': collapsed[producto.name1 + '_' + cat.name], 
                                   'fa-chevron-up': !collapsed[producto.name1 + '_' + cat.name]}"></i>
                  </span>
                  <span class="categoria-name">{{ cat.name | translate }}</span>
                  
                  <span *ngIf="loadingRenting && lastOpenedId === producto.name1 + '_' + cat.name" 
                        class="loading-spinner">
                    <fa-icon [icon]="faSpinner" [spin]="true"></fa-icon>
                  </span>
                </div>
              </div>
              
              <div *ngIf="!collapsed[producto.name1 + '_' + cat.name]" 
                   class="categoria-documentos">
                
                <div *ngIf="mostrarMensajeNoDocumentos && !loadingRenting" 
                     class="alert alert-warning" 
                     [innerHTML]="'No hay documentos disponibles en esta categoría.'|translate">
                </div>
                
                <div *ngFor="let doc of documentos" class="documento-item">
                  <ng-container *ngIf="doc.category === cat.name && productName === producto.name1 && !loadingRenting && !mostrarMensajeNoDocumentos">
                    <a *ngIf="doc.title !== 'Pictures'" 
                       href="https://cms.eft-systems.de/{{ doc.file }}" 
                       target="_blank" 
                       class="documento-link">
                      {{ doc.title }}
                    </a>
                    <a *ngIf="doc.title === 'Pictures'" 
                       (click)="downloadMultipleFiles()" 
                       class="documento-link">
                      {{ 'Pictures' | translate }}
                    </a>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
  </div>
</div>

<app-footer></app-footer>
